import { Component } from '@angular/core';
import { config } from 'rxjs/internal/config';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class InfoComponent {
  socialLinks: any;


  ngOnInit(): void{
 
  }
openWhatsApp() {
  const phoneNumber = '919154730496'; // country code + number, no + or spaces
  const message = ''; // ఒకవేళ pre-filled message కావాలంటే ఇక్కడ text పెట్టండి, e.g. 'Hi, I need info about Gold Bharat'

  const url = message
    ? `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${phoneNumber}`;

  window.open(url, '_blank');
}
}
